export default {
    series: value => !value || /^\d{2}(\s?)\d{2}$/i.test(value.trim()) ? undefined : '4 цифры',
    number: value => !value || /^\d{6}$/i.test(value.trim()) ? undefined : '6 цифр',
}

